/**
 * @generated SignedSource<<61f3660efafd4bacd0048234aee9be6e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GroupsSettingsRootQuery$variables = Record<PropertyKey, never>;
export type GroupsSettingsRootQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AccessControlSettingsPage_query">;
};
export type GroupsSettingsRootQuery = {
  response: GroupsSettingsRootQuery$data;
  variables: GroupsSettingsRootQuery$variables;
};

const node: ConcreteRequest = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "GroupsSettingsRootQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "AccessControlSettingsPage_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "GroupsSettingsRootQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CurrentUser",
        "kind": "LinkedField",
        "name": "whoami",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "displayName",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "kind": "ClientExtension",
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UrlConfig",
            "kind": "LinkedField",
            "name": "UrlConfig",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "docs",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "2d381dab96580fe380373f7a99a5e6c8",
    "id": null,
    "metadata": {},
    "name": "GroupsSettingsRootQuery",
    "operationKind": "query",
    "text": "query GroupsSettingsRootQuery {\n  ...AccessControlSettingsPage_query\n}\n\nfragment AccessControlSettingsPage_query on Query {\n  ...PageWithBreadCrumbs_query\n}\n\nfragment BreadCrumbsHeader_query on Query {\n  whoami {\n    email\n    displayName\n  }\n}\n\nfragment PageWithBreadCrumbs_query on Query {\n  ...BreadCrumbsHeader_query\n}\n"
  }
};

(node as any).hash = "97b3b8d8382552e95d950bbbd0151fbc";

export default node;
